import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { Publication } from 'src/app/models/business/Publication';

const useStyles = makeStyles(() => ({
  metricGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 16,
    marginBottom: 8,
  },
  metricCard: {
    borderRadius: 12,
    border: '1px solid #eadfd1',
    padding: '14px 16px',
    minHeight: 72,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  metricPink: { background: '#fdeaf1' },
  metricGreen: { background: '#eef6da' },
  metricRose: { background: '#f7ebea' },
  metricGold: { background: '#fff3d8' },
  metricTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#8d7d70',
    fontSize: 13,
    fontWeight: 700,
  },
  metricValue: {
    fontSize: 28,
    fontWeight: 800,
    lineHeight: 1,
    color: '#624f42',
  },
}));

interface MetricsCardsProps {
  publications: Publication[];
  totalCount?: number;
}

const isActiveStatus = (status: string) => {
  return status === '1';
};

export const MetricsCards = ({ publications, totalCount }: MetricsCardsProps) => {
  const classes = useStyles();

  const metrics = useMemo(() => {
    const activeCount = publications.filter((item) => isActiveStatus(item.publication_state_id)).length;
    const inactiveCount = publications.length - activeCount;
    const total = totalCount ?? publications.length;

    return [
      { title: 'Total publicaciones', value: String(total), tone: 'pink' },
      { title: 'Activas', value: String(activeCount), tone: 'green' },
      { title: 'Inactivas', value: String(inactiveCount), tone: 'rose' },
      { title: 'En campaña', value: String(activeCount), tone: 'gold' },
    ];
  }, [publications, totalCount]);

  const toneClassMap = {
    pink: classes.metricPink,
    green: classes.metricGreen,
    rose: classes.metricRose,
    gold: classes.metricGold,
  };

  return (
    <div className={classes.metricGrid}>
      {metrics.map((metric) => (
        <div
          key={metric.title}
          className={`${classes.metricCard} ${toneClassMap[metric.tone as keyof typeof toneClassMap]}`}
        >
          <div className={classes.metricTitle}>
            <span>{metric.title}</span>
          </div>
          <div className={classes.metricValue}>{metric.value}</div>
        </div>
      ))}
    </div>
  );
};
